import {
  CANCEL_ATA_SUCCESS,
  CLEAR_ARN_DATA_SUCCESS,
  CREATE_ASSET_RECEIPT_NOTE_SUCCESS,
  FETCH_ARN_NO_SUCCESS,
  FETCH_ASSET_LIST_BY_ATA,
  FETCH_ASSET_RECEIPT_NOTE_SUCCESS,
  FETCH_METER_UNIT_SUCCESS_ARN,
  GET_ASSET_RECEIPT_NOTE_SUCCESS,
  SAVE_ASSET_RECEIPT_NOTE_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  assetListByAta: [],
  arnNo: 0,
  meterUnit : []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ASSET_RECEIPT_NOTE_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_ASSET_RECEIPT_NOTE_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_ASSET_RECEIPT_NOTE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_ASSET_RECEIPT_NOTE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case FETCH_ASSET_LIST_BY_ATA: {
      return {
        ...state,
        assetListByAta: action.data,
      };
    }

    case FETCH_METER_UNIT_SUCCESS_ARN: {
      return {
        ...state,
        meterUnit: action.data,
      }
    }

    case FETCH_ARN_NO_SUCCESS : {
      return {
        ...state,
        arnNo: action.data,
      };
    }

    case CANCEL_ATA_SUCCESS : {
      return {
        ...state,
      };
    }

    case CLEAR_ARN_DATA_SUCCESS: {
      return {
        ...state,
        assetListByAta: [],
        arnNo: 0,
        edit: {},
      }
    }

    default:
      return state;
  }
}
